// extracted by mini-css-extract-plugin
export default {"toggle":"ShowHideToggle__toggle___3eN1s","open":"ShowHideToggle__open___2EIlN","main":"ShowHideToggle__main___KxQTk"};